var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "copy-03"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M7.00024 6.66675V4.33341C7.00024 3.39999 7.00024 2.93328 7.1819 2.57676C7.34169 2.26316 7.59666 2.00819 7.91026 1.8484C8.26678 1.66675 8.73349 1.66675 9.66691 1.66675H16.0002C16.9337 1.66675 17.4004 1.66675 17.7569 1.8484C18.0705 2.00819 18.3255 2.26316 18.4853 2.57676C18.6669 2.93328 18.6669 3.39999 18.6669 4.33341V10.6667C18.6669 11.6002 18.6669 12.0669 18.4853 12.4234C18.3255 12.737 18.0705 12.992 17.7569 13.1518C17.4004 13.3334 16.9337 13.3334 16.0002 13.3334H13.6669M4.66691 18.3334H11.0002C11.9337 18.3334 12.4004 18.3334 12.7569 18.1518C13.0705 17.992 13.3255 17.737 13.4853 17.4234C13.6669 17.0669 13.6669 16.6002 13.6669 15.6667V9.33341C13.6669 8.39999 13.6669 7.93328 13.4853 7.57676C13.3255 7.26316 13.0705 7.00819 12.7569 6.8484C12.4004 6.66675 11.9337 6.66675 11.0002 6.66675H4.66691C3.73349 6.66675 3.26678 6.66675 2.91026 6.8484C2.59666 7.00819 2.34169 7.26316 2.1819 7.57676C2.00024 7.93328 2.00024 8.39999 2.00024 9.33341V15.6667C2.00024 16.6002 2.00024 17.0669 2.1819 17.4234C2.34169 17.737 2.59666 17.992 2.91026 18.1518C3.26678 18.3334 3.73349 18.3334 4.66691 18.3334Z",
    stroke: "#004DCD",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyBlue);
export default __webpack_public_path__ + "static/media/copy-blue.f1f45c219e27b00a00f63d5c4fbcb03b.svg";
export { ForwardRef as ReactComponent };